import React from "react";

export const FUNDING_SOURCES = [
    {value: "EMP", name: "Employment"},
    {value: "GIFT", name: "Gift"},
    {value: "TRUST", name: "Inheritance / Trust"},
    {value: "INVESTMENT", name: "Investment Proceeds"},
    {value: "SAVINGS", name: "Savings"},
    {value: "RETIRE", name: "Retirement Funds"},
    {value: "GAMBLING", name: "Gambling"},
    {value: "LEGAL", name: "Legal Settlement"},
    {value: "FAMILY", name: "Spouse / Parent"},
    {value: "UNEMP", name: "Unemployment / Disability"},
    {value: "ROLLOVER", name: "Rollover"},
    {value: "RENT", name: "Rental Income"},
    {value: "SALE", name: "Sale of Business"},
    {value: "INSURANCE", name: "Insurance Proceeds"},
]